import { WelcomeService } from "./welcome.service";
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  TemplateRef,
  AfterViewInit,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";

import * as _ from "underscore";
import { JobsService } from "../jobs-and-tasks/jobs.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NgClass } from "@angular/common";
import { DashboardService } from "src/app/dashboard/dashboard.service";

// declare var jQuery: any;

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"],
  standalone: true,
})
export class WelcomeComponent implements OnInit {
  user: any = {};
  validUsers = [
    "fabiancabau@gmail.com",
    "khosla.samir+p14@gmail.com",
    "christiangusukuma@gmail.com",
    "testclienthub@gmail.com",
  ];
  page: any;
  content: any = "";
  constructor(
    private localStorage: LocalStorageService,
    private welcomeService: WelcomeService,
    public jobsService: JobsService,
    public _sanitizer: DomSanitizer,
    private dashboardService: DashboardService,
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.localStorage.set("fromSignIn", false);
    if (this.validUsers.includes(this.user.email)) {
    }
    this.dashboardService.show_loading.next(true);
    this.welcomeService.getWelcomePage().then((res) => {
      this.content = res.content;
      this.dashboardService.show_loading.next(false);
    });
  }

  async save() {
    this.welcomeService.saveWelcomePage(this.content).then((res) => {
      console.log(res);
    });
  }
}
